import styled, { css } from 'styled-components';
import { breakpoint, sizes } from 'variables';
import { getNumberOfItems } from '../index';
import type { InventoryLaneProps } from '../shared/types';
import InventoryLaneItem from './InventoryLaneItem';

const List = styled.div<{ $noOfItemsDesktop: number }>`
    display: grid;
    grid-column-gap: ${({ theme }) => theme.Spacing8};
    grid-row-gap: ${({ theme }) => theme.Spacing16};
    grid-template-columns: repeat(2, calc(50% - ${({ theme }) => theme.Spacing4}));
    justify-content: center;

    ${breakpoint.up('375px')} {
        grid-column-gap: ${({ theme }) => theme.Spacing16};

        ${({ $noOfItemsDesktop }) =>
            ($noOfItemsDesktop === 0 && 'display: none;') ||
            ($noOfItemsDesktop <= 4 && 'grid-template-columns: repeat(2, 160px);') ||
            ($noOfItemsDesktop <= 6 && 'grid-template-columns: repeat(3, 160px);')}
    }

    ${breakpoint.up('768px')} {
        ${({ $noOfItemsDesktop }) =>
            $noOfItemsDesktop <= 4 &&
            css`
                grid-template-columns: repeat(${$noOfItemsDesktop}, 160px);
            `}
    }

    ${breakpoint.up('1025px')} {
        ${({ $noOfItemsDesktop }) =>
            $noOfItemsDesktop !== 0 &&
            css`
                grid-template-columns: repeat(${$noOfItemsDesktop}, 160px);
            `}
    }
`;

export default function InventoryLaneList({ content }: { content: InventoryLaneProps }) {
    const { noOfItemsMobile, noOfItemsDesktop } = getNumberOfItems(content);

    return (
        <List $noOfItemsDesktop={noOfItemsDesktop}>
            {content.inventoryLaneBlocks.map((block, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <InventoryLaneItem key={i} inventoryLaneBlock={block} noOfItemsMobile={noOfItemsMobile} />
            ))}
        </List>
    );
}
